import { render, staticRenderFns } from "./addNoticeMsg.vue?vue&type=template&id=7ed43e62&"
import script from "./addNoticeMsg.vue?vue&type=script&lang=js&"
export * from "./addNoticeMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ed43e62')) {
      api.createRecord('7ed43e62', component.options)
    } else {
      api.reload('7ed43e62', component.options)
    }
    module.hot.accept("./addNoticeMsg.vue?vue&type=template&id=7ed43e62&", function () {
      api.rerender('7ed43e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/noticeComponent/addNoticeMsg.vue"
export default component.exports